"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var currency_1 = require("@nerdwallet/currency");
var ChevronRight_1 = __importDefault(require("@nerdwallet/react-icon/material/ChevronRight"));
var variables_1 = require("../../../styles/variables");
var nerdwallet_plus_logo_1 = require("../../nerdwallet-plus-logo");
var drawer_context_1 = require("../drawer-context");
var useIsScrolling_1 = __importDefault(require("../../../utils/hooks/useIsScrolling"));
var drawer_button_module_css_1 = __importDefault(require("./drawer-button.module.css"));
var NW_PLUS_LOGO_PX_RULES = {
    small: {
        width: 36,
        height: 20,
    },
    standard: {
        width: 138,
        height: 20,
    },
};
var DrawerButton = function (_a) {
    var _b = _a.changeOnScroll, changeOnScroll = _b === void 0 ? true : _b;
    var open = (0, drawer_context_1.useDrawerContext)().open;
    var isScrolling = (0, useIsScrolling_1.default)({ debounceTime: 1000 });
    return (react_1.default.createElement(currency_1.Box, { component: "button", type: "button", onClick: open, className: drawer_button_module_css_1.default.drawerButton },
        isScrolling && changeOnScroll ? (react_1.default.createElement(nerdwallet_plus_logo_1.NerdWalletPlusLogo, { small: true, width: NW_PLUS_LOGO_PX_RULES.small.width, height: NW_PLUS_LOGO_PX_RULES.small.height })) : (react_1.default.createElement(nerdwallet_plus_logo_1.NerdWalletPlusLogo, { width: NW_PLUS_LOGO_PX_RULES.standard.width, height: NW_PLUS_LOGO_PX_RULES.small.height })),
        react_1.default.createElement(ChevronRight_1.default, { size: "medium", color: variables_1.colors["green"] })));
};
exports.default = DrawerButton;
